import { createElement } from 'react'

import { Table } from 'shared/components'

import {
  ApproveMemberInvoicePayment,
  CancelMemberInvoicePayment,
} from '../../shared/components'

export const createColumns = () => [
  {
    Header: 'Amount',
    accessor: 'amount',
    maxWidth: 80,
    width: 80,
  },
  {
    Header: 'Creation Date',
    accessor: 'creationDate',
    Cell: Table.CellRenderers.DateTimeCell,
    minWidth: 400,
    width: 400,
  },
  {
    Header: 'Currency',
    accessor: 'currency',
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'Current state',
    accessor: 'currentState',
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'Member id',
    accessor: 'memberId',
    maxWidth: 50,
    width: 50,
  },
  {
    Header: 'Number',
    accessor: 'number',
    minWidth: 300,
    width: 300,
  },
  {
    Header: 'Approve',
    id: 'controls',
    accessor: (value) => value,
    Cell: (props) => createElement(ApproveMemberInvoicePayment, { ...props }),
  },
  {
    Header: 'Cancel',
    id: 'controls',
    accessor: (value) => value,
    Cell: (props) => createElement(CancelMemberInvoicePayment, { ...props }),
  },
]
